import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar2 from "../components/Navbar2";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Navbar from "../components/Navbar";
import NavbarMob from "../components/NavbarMob";
import Navbar2Mob from "../components/Navbar2Mob";
import Select from "react-select";

function EnableStaff() {
    const [staffData, setStaffData] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [pendingHiddenLocations, setPendingHiddenLocations] = useState({});
    const [savingHiddenLocations, setSavingHiddenLocations] = useState({});
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const [searchQuery, setSearchQuery] = useState({
        companyName: "",
        mobileNumber: "",
        email: "",
        address: "",
        customerType: "",
    });

    const parseHiddenLocations = (value) => {
        if (Array.isArray(value)) return value;
        return (value || "")
            .split(",")
            .map((location) => location.trim())
            .filter(Boolean);
    };

    // Fetch staff list
    useEffect(() => {
        fetch(`${apiBaseUrl}/fetchallstaff`)
            .then((res) => {
                if (!res.ok) throw new Error(`Failed to load staff: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                console.log("Full staff data received from server:", data); // ← most useful
                console.log("First staff item (if exists):", data[0]); // quick check structure
                console.log("Total staff count:", data.length);
                setStaffData(data);
            })
            .catch((err) => {
                console.error("Error loading staff:", err);
            });
    }, [apiBaseUrl]);

    useEffect(() => {
        fetch(`${apiBaseUrl}/data`)
            .then((res) => {
                if (!res.ok) throw new Error(`Failed to load locations: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                const locations = data?.states?.flatMap((state) => state.districts || []) || [];
                const uniqueLocations = [...new Set(locations.filter(Boolean))].sort();
                setLocationOptions(uniqueLocations.map((location) => ({ value: location, label: location })));
            })
            .catch((err) => {
                console.error("Error loading locations:", err);
            });
    }, [apiBaseUrl]);

    const filteredStaffData = staffData.filter((staff) =>
        Object.keys(searchQuery).every((key) => {
            const query = searchQuery[key].trim().toLowerCase();
            if (!query) return true;
            return (staff[key] || "").toString().toLowerCase().includes(query);
        })
    );

    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchQuery((prev) => ({ ...prev, [name]: value }));
    };

    // Toggle Enable Job Post
    const toggleJobPost = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, power: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updatepower`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName, // ← changed
                    power: newValue,
                }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || "Failed");
        } catch (err) {
            console.error(err);
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, power: currentValue } : s)));
            alert("Failed to update Job Post");
        }
    };

    // Toggle Special Power
    const toggleSpecialPower = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, specialPower: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updatespecialpower`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName, // ← changed
                    specialPower: newValue,
                }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || "Failed");
        } catch (err) {
            console.error(err);
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, specialPower: currentValue } : s)));
            alert("Failed to update Special Power");
        }
    };

    // Toggle Enable Package
    const toggleEnablePackage = async (staffId, currentValue, companyName) => {
        const newValue = currentValue === "on" ? "off" : "on";

        // Optimistic update
        setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, enablePackage: newValue } : s)));

        try {
            const res = await fetch(`${apiBaseUrl}/updateEnablepackage`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    companyName,
                    enablePackage: newValue,
                }),
            });

            const data = await res.json();

            if (!res.ok || !data?.success) {
                throw new Error(data?.message || "Update failed");
            }

            // ── MOST IMPORTANT PART ──
            // Re-fetch fresh data from server after successful update
            const freshResponse = await fetch(`${apiBaseUrl}/fetchallstaff`);
            const freshData = await freshResponse.json();
            setStaffData(freshData);

            console.log("Enable Package updated & list refreshed");
        } catch (err) {
            console.error("Failed to update enable package:", err);

            // Rollback
            setStaffData((prev) => prev.map((s) => (s.staffId === staffId ? { ...s, enablePackage: currentValue } : s)));

            alert("Could not update Enable Package. Please try again.");
        }
    };

    const updateHiddenLocations = async (staffId, selectedOptions, companyName) => {
        const hiddenLocations = (selectedOptions || []).map((option) => option.value);
        const previousStaff = staffData.find((staff) => staff.staffId === staffId);
        const previousHiddenLocations = previousStaff?.hiddenLocations || "";
        const newValue = hiddenLocations.length > 0 ? "on" : "off";

        setStaffData((prev) =>
            prev.map((s) =>
                s.staffId === staffId
                    ? { ...s, locationPower: newValue, hiddenLocations: hiddenLocations.join(",") }
                    : s,
            ),
        );

        try {
            setSavingHiddenLocations((prev) => ({ ...prev, [staffId]: true }));
            const res = await fetch(`${apiBaseUrl}/updatelocationpower`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    staffId,
                    companyName,
                    locationPower: newValue,
                    hiddenLocations,
                }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.message || "Failed");
            setStaffData((prev) =>
                prev.map((s) =>
                    s.staffId === staffId
                        ? {
                              ...s,
                              locationPower: data.locationPower ?? newValue,
                              hiddenLocations: data.hiddenLocations ?? hiddenLocations.join(","),
                          }
                        : s,
                ),
            );
            setPendingHiddenLocations((prev) => {
                const next = { ...prev };
                delete next[staffId];
                return next;
            });
        } catch (err) {
            console.error(err);
            setStaffData((prev) =>
                prev.map((s) =>
                    s.staffId === staffId
                        ? {
                              ...s,
                              locationPower: previousHiddenLocations ? "on" : "off",
                              hiddenLocations: previousHiddenLocations,
                          }
                        : s,
                ),
            );
            alert(err.message || "Failed to update hidden locations");
        } finally {
            setSavingHiddenLocations((prev) => ({ ...prev, [staffId]: false }));
        }
    };

    const getSelectedHiddenLocationOptions = (staff) => {
        const locations = pendingHiddenLocations[staff.staffId] ?? parseHiddenLocations(staff.hiddenLocations);
        return locations.map((location) => ({
            value: location,
            label: location,
        }));
    };

    const saveHiddenLocations = (staff) => {
        updateHiddenLocations(staff.staffId, getSelectedHiddenLocationOptions(staff), staff.companyName);
    };

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="hidden md:block">
                <Navbar2 />
            </div>
            <div className="md:hidden">
                <Navbar2Mob />
            </div>

            <div className="flex-1 px-4 py-10 sm:px-8 lg:px-16">
                <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">Manage Staff Permissions</h1>

                <div className="overflow-x-auto rounded-lg shadow">
                    <table className="min-w-full divide-y divide-gray-200 bg-white">
                        <thead className="bg-blue-700 text-white">
                            <tr>
                                <th className="px-4 py-3 text-center  font-semibold">Staff Name</th>
                                <th className="px-4 py-3 text-center  font-semibold">Mobile</th>
                                <th className="px-4 py-3 text-center  font-semibold">Type</th>
                                <th className="px-4 py-3 text-center  font-semibold">Password</th>
                                <th className="px-4 py-3 text-center  font-semibold">Enable Job Post</th>
                                <th className="px-4 py-3 text-center  font-semibold">Special Power</th>
                                <th className="px-4 py-3 text-center  font-semibold">Enable Package</th>
                                <th className="px-4 py-3 text-center  font-semibold">Hide Locations</th>
                                <th className="px-4 py-3 text-center  font-semibold">Change Credentials</th>
                                {/* <th className="px-4 py-3 text-center text-sm font-semibold">Change Mobile</th> */}
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {filteredStaffData.map((staff) => (
                                <tr key={staff.staffId} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{staff.companyName}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.mobileNumber || "—"}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.customerType || "—"}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">{staff.password || "—"}</td>

                                    {/* Enable Job Post */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() => toggleJobPost(staff.staffId, staff.power, staff.companyName)}
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                staff.power === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {staff.power === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    {/* Special Power */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() =>
                                                toggleSpecialPower(staff.staffId, staff.specialPower, staff.companyName)
                                            }
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                (staff.specialPower ?? "off") === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {(staff.specialPower ?? "off") === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    {/* Enable Package – now separate */}
                                    <td className="px-4 py-3 text-center">
                                        <button
                                            onClick={() =>
                                                toggleEnablePackage(staff.staffId, staff.enablePackage, staff.companyName)
                                            }
                                            className={`px-6 py-2 rounded-md text-white font-medium min-w-[80px] transition ${
                                                (staff.enablePackage ?? "off") === "on"
                                                    ? "bg-green-600 hover:bg-green-700"
                                                    : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        >
                                            {(staff.enablePackage ?? "off") === "on" ? "ON" : "OFF"}
                                        </button>
                                    </td>

                                    <td className="px-4 py-3 min-w-[360px]">
                                        <div className="flex items-center gap-2">
                                            <div className="min-w-[260px] flex-1">
                                                <Select
                                                    isMulti
                                                    options={locationOptions}
                                                    value={getSelectedHiddenLocationOptions(staff)}
                                                    onChange={(selectedOptions) =>
                                                        setPendingHiddenLocations((prev) => ({
                                                            ...prev,
                                                            [staff.staffId]: (selectedOptions || []).map((option) => option.value),
                                                        }))
                                                    }
                                                    placeholder="Select locations to hide"
                                                    className="text-left text-sm"
                                                    classNamePrefix="react-select"
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => saveHiddenLocations(staff)}
                                                disabled={savingHiddenLocations[staff.staffId]}
                                                className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 font-medium transition"
                                            >
                                                {savingHiddenLocations[staff.staffId] ? "Saving" : "Save"}
                                            </button>
                                        </div>
                                    </td>

                                    <td className="px-4 py-3 text-center">
                                        <div className="flex items-center justify-center gap-4">
                                            <button
                                                onClick={() => navigate(`/change-staff-credentials/${staff.staffId}`)}
                                                className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 font-medium transition"
                                            >
                                                Edit
                                            </button>
                                            {/* Separate credential links kept for future reuse.
                                            <button
                                                onClick={() => navigate(`/change-staff-credentials/${staff.staffId}`)}
                                                className="text-blue-600 hover:text-blue-800 font-medium underline"
                                            >
                                                Staff Name
                                            </button>
                                            <button
                                                onClick={() => navigate(`/change-staff-credentials/${staff.staffId}`)}
                                                className="text-blue-600 hover:text-blue-800 font-medium underline"
                                            >
                                                Mobile
                                            </button>
                                            <button
                                                onClick={() => navigate(`/change-staff-credentials/${staff.staffId}`)}
                                                className="text-red-600 hover:text-red-800 font-medium underline"
                                            >
                                                Password
                                            </button>
                                            */}
                                            {/* Old separate credential pages kept for future reuse.
                                            <button
                                                onClick={() => navigate(`/change-mobile/${staff.staffId}`)}
                                                className="text-blue-600 hover:text-blue-800 font-medium underline"
                                            >
                                                Change Mobile
                                            </button>
                                            <button
                                                onClick={() => navigate(`/change-password/${staff.staffId}`)}
                                                className="text-red-600 hover:text-red-800 font-medium underline"
                                            >
                                                Change Password
                                            </button>
                                            */}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default EnableStaff;
